import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { SessionTimerService } from '../services/session-timer.service';

export const generalGuard: CanActivateFn = (route, state) => {
     const authService = inject(AuthenticationService);

     /* step 1: Are they authenticated? */
     let isAuthenticated = (!authService.setUser() && !authService.getUser()) ? false : true;
     if (isAuthenticated) {
          const roles = authService.getRoles();
          const isAuthenticated: boolean = roles !== null && roles.length > 0;
          const hasAgreedToTerms = authService.getHasAgreedToTerms();
          const isCsr = roles && roles.includes('csr_user');
          const isAdmin = roles && roles.includes('mc_useradmin');
          const canRequestRecords = roles && roles.includes('mc_request');
          if(route.routeConfig!.path!.toString().includes('userAccountAdmin') ||
               route.routeConfig!.path!.toString() === 'wsAPI' ||
               route.routeConfig!.path!.toString() === 'wsToken'
          ){
               if(!isAuthenticated || !isAdmin || !hasAgreedToTerms || isCsr){
                    return inject(Router).navigate(['/accessDenied']);
               }
          }

          const userProfile = authService.getUserProfile();

          // determine if the user is a monthly account holder
          let isMah = false;
          const customerType = userProfile?.customerType;
          // 1 = MC; 6 = ISP; 4 = TPIP; 5 = SuperTPIP;
          const mahCustomerTypes = [1,4,5,6];
          if (customerType && mahCustomerTypes.includes(customerType)) {
              isMah = true;
          }

          let showInvoices = false;
     
          if (isMah) {
               if (userProfile?.userData.email.toLowerCase() === userProfile?.customer.powerUserEmail?.toLowerCase()) {
                    showInvoices = true;
               } else if (userProfile?.userData.email.toLowerCase() === userProfile?.customer.billingInfo?.contactEmailId?.toLowerCase()) {
                    showInvoices = true;
               }
          }

          if(route.routeConfig!.path!.toString() === 'billingReports' || 
               route.routeConfig!.path!.toString() === 'billing-summary' || 
               route.routeConfig!.path!.toString() === 'single-paper-invoice' || 
               route.routeConfig!.path!.toString() === 'generic-statement' ||
               route.routeConfig!.path!.toString().includes('invoice')){
               if(!isAuthenticated || !isMah || !showInvoices || !hasAgreedToTerms || isCsr){
                    return inject(Router).navigate(['/accessDenied']);
               }
          }

          if(route.routeConfig!.path!.toString() === 'wsAPI' || 
          route.routeConfig!.path!.toString() === 'wsToken'){
               if(!isAuthenticated || !isMah || !isAdmin || !hasAgreedToTerms || isCsr){
                    return inject(Router).navigate(['/accessDenied']);
               }
          }


          if(route.routeConfig!.path!.toString() === 'requestRecords'){
               if(!isAuthenticated || !hasAgreedToTerms || isCsr || !canRequestRecords){
                    return inject(Router).navigate(['/accessDenied']);
               }
          }

          if(route.routeConfig!.path!.toString() === 'news'){
               if(!isAuthenticated || !hasAgreedToTerms || isCsr){
                    return inject(Router).navigate(['/accessDenied']);
               }
          }

          return true;
     } else {
          /* step 1b: Is the user in an authorized role to see the given page? */
          // not logged in so redirect to login page with the return url
          if (window.location.href.includes('/byAuthCode/')) {
               authService.setDeepLink(window.location.href);
          } else {
               authService.setDeepLink('');
          }
          return inject(Router).navigate(['/']);
     }
};
